export default function objectToUrlQuery(obj: Record<string, any>): string{
    let list = Object
        .keys(obj)
        .map(key => obj[key] === undefined ? undefined : `${encodeURI(key)}=${encodeURIComponent(obj[key]?.toString())}`)
        .filter(s => s);
    return list.join("&");
}